<template>
  <q-page>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6 q-pa-sm">
        <div v-if="false" class="text-center">物料用量最多前五（{{ month }}月）</div>
        <q-table
          v-if="productUseTopFive && productUseTopFive.length > 0"
          :title="`物料用量最多前五（${month}月）`"
          class="full-height"
          :data="productUseTopFive"
          :columns="columns"
          :pagination.sync="tableSet"
        >
        </q-table>
        <VueApexCharts v-if="false" type="bar" height="350" :options="productUseTopFive.chartOptions" :series="productUseTopFive.series"></VueApexCharts>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6 q-pa-sm">
        <SuggestProduct :is-list="false" ></SuggestProduct>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6 q-pa-sm">
        <PurchaseEffective></PurchaseEffective>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <router-link :to="'/product/sale'">
          <q-btn
            color="blue"
            icon="how_to_vote"
            label="銷售"
            class="full-width"
            size="lg"
          ></q-btn>
          </router-link>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <router-link :to="'/collar/pos'">
          <q-btn
            color="blue"
            icon="how_to_vote"
            label="領用"
            class="full-width"
            size="lg"
          ></q-btn>
        </router-link>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import SuggestProduct from './Product/components/SuggestProduct'
import PurchaseEffective from './Purchase/components/Effective'

export default {
  name: 'PageHome',
  components: { VueApexCharts, SuggestProduct, PurchaseEffective },
  data () {
    return {
      month: "",
      columns: [
        { name: 'title', align: 'center', label: '物料', field: 'title', sortable: true,},
        { name: 'count', align: 'center', label: '已用數量', field: 'count', sortable: true,},
      ],
      tableSet: {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 5
      },
      series: [{
        name: '',
        data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65, 35]
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          zoom: {
            enabled: false
          },
        },
        stroke: {
          width: 1
        },
        xaxis: {
          categories: ['Apples', 'Oranges', 'Strawberries', 'Pineapples', 'Mangoes', 'Bananas',
            'Blackberries', 'Pears', 'Watermelons', 'Cherries', 'Pomegranates', 'Tangerines', 'Papayas'
          ],
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100]
          },
        }
      },
    }
  },
  computed: {
    ...mapGetters(['productUseTopFive','loginUser'])
  },
  created() {
    let now = new Date()
    this.month = now.getMonth()+1
    this.$store.dispatch("productPutUsedTopFive")
  }
}
</script>
